import React, { useState } from 'react';
import classes from './Cashbacks.qmee.module.scss';
import OffersControls from 'components/molecules/OffersControls/OffersControls';
import OffersListingPage from 'components/pages/Offers/OffersListingPage';
import { useOfferCategoryNavigation } from 'components/pages/Offers/useOfferCategoryNavigation';
import useOffers from 'components/pages/Offers/useOffers';
import { useDebounce } from 'hooks/useDebounce';
import { PROMOTION_TAG } from 'utils/offers';
import { CASHBACK } from '../pages';

export interface ListingProps {
  selectedCategory?: string;
}

const Cashbacks: React.FC<ListingProps> = ({ selectedCategory: initialSelectedCategory }) => {
  const { listRef, handleCategorySelect, selectedCategory } =
    useOfferCategoryNavigation(initialSelectedCategory);

  const [searchQuery, setSearchQuery] = useState('');
  const debouncedSearchQuery = useDebounce(searchQuery);

  const { items, promoItem, categories } = useOffers({
    apiField: 'cashbacks',
    requiredTags: [],
    rejectedTags: ['gaming'],
    promoRejectedTags: ['gaming'],
    paysReward: true,
    selectedCategory,
    basePath: CASHBACK.path,
    offerType: 'cashback',
    promoTags: [PROMOTION_TAG],
    searchQuery: debouncedSearchQuery,
  });

  return (
    <div className={classes.root}>
      <OffersControls
        categories={categories}
        selectedCategory={selectedCategory}
        onCategorySelect={handleCategorySelect}
        searchQuery={searchQuery}
        onSearchChange={setSearchQuery}
        listRef={listRef}
      />
      <OffersListingPage
        items={items}
        promoItem={promoItem}
        searchQuery={searchQuery}
        categories={categories}
        selectedCategory={selectedCategory}
        onCategorySelect={handleCategorySelect}
        offerType="cashback"
      />
    </div>
  );
};

export default Cashbacks;
